schoolwork12.app.creManagement = {
    name: "Pathway Requirements",
    routes: {
        base: {
            route: "/pathway-requirements",
            template: "ng-migration/cre-tracking/components/cre-management.page.html"
        },
        details: {
            title: "Pathway Details",
            route: "/details",
            template: "<app-cre-school-detail></app-cre-school-detail>",
        },
    },
    endpoints: {
        ctePathways: (school) => `/schools/${school}/dropDownDetails/type/2`,
        ctePathwayDetail: (pathway) => `/school/pathway/activecourse/${pathway}`,
        cteCourseList: (school) => `/school/pathway/course-list/${school}`,
        ctePathwaySave: "/school/pathway/save",
        schoolTypes: "/schools/getAllSchools"
    },
    errorMessages: {},
};
